module.exports = __webpack_public_path__ + "img/245.b4684a28.png";